import { KText } from '@/ui-library/components';
import { components } from 'react-select';

/**
 * Default GroupHeading component for grouped select options
 * Can be used with KSelect, KSelectField, or any react-select based component
 *
 * Usage:
 * ```tsx
 * import { KGroupHeading } from '@/ui-library/components/organisms/KFields/KGroupHeading';
 *
 * <KSelect
 *   options={groupedOptions}
 *   customComponents={{
 *     GroupHeading: KGroupHeading
 *   }}
 * />
 * ```
 */
export const KGroupHeading = (props: any) => {
  return (
    <components.GroupHeading {...props}>
      <KText size="sm-semi-bold" color="secondary-900">
        {props.children}
      </KText>
    </components.GroupHeading>
  );
};
